module.exports = __webpack_public_path__ + "img/check.d5c10cb8.svg";